<template>
	<div>
		<label>
			<span class="l_title">Размер поля</span>
			<Select2 v-model="params.size" :options="sizes" :settings="{multiple: false,minimumResultsForSearch: -1}" />
		</label>
		<div class="razd"></div>
		<label class="check_label" v-show="!autoSettings">
			<input type="checkbox" class="uk-checkbox" v-model="params.show_reactions">
			<span>Анимации</span>
		</label>
	</div>
</template>

<script>
  import Select2 from "v-select2-component";
  export default {
    name: "settings",
	  components: {
      Select2
	  },
    watch: {
      params: {
        handler: function (newValue) {
          if (!this.ingame) {
            this.$emit('params_changed', this.params);
          }
        },
        deep: true
      },
    },
    data() {
      return {
        params: '',
        sizes: [
          {
            id: '3',
            text: '3x3'
          },
          {
            id: '4',
            text: '4x4'
          },
          {
            id: '5',
            text: '5x5'
          },
          {
            id: '6',
            text: '6x6'
          },
          {
            id: '7',
            text: '7x7'
          },
          {
            id: '8',
            text: '8x8'
          },
        ],
      }
    },
    props: {
      items: '',
      is_homework: '',
      autoSettings: ''
    },
    computed: {
      role() {
        return this.$store.state.user.role.code;
      },
    },
    methods: {},
    mounted() {
      this.params = this.$store.state.train.gorbov_params;
    }
  }
</script>